'use client';
import React, {useLayoutEffect, useRef, useState} from 'react';
import VerticalSingleSelection from '../components/vertical_single_selection';
import { ColorLimit, SelectionData, Choice } from '../questions';
import { Box, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ClientComponent from '@/components/builder/client_component';
import cssStyles  from "./questioniar_component.module.scss";

const ColorPalleteSingleSelection: React.FC<SelectionData> = ({selectedAnswer, setSelectedAnswer, choices, editData, ...props}) => {
  
    let previousChoiceId = "";
    const differentColors = Object.keys(choices) as Array<string>;
    const [updateDOM, setUpdateDOM] = useState(new Date().getMilliseconds());
    const itemsIndex = useRef(0);
    const items = useRef<string[]>([]);

    useLayoutEffect(()=>{
      if(itemsIndex.current==0 && itemsIndex.current < ColorLimit) {
        handleShowMore(null);
      }
    },[])

    const handleShowLess = (e:React.MouseEvent<HTMLAnchorElement> |  null) => {
      if(e){
        e.preventDefault();
      }
      itemsIndex.current = ColorLimit;
      items.current.length = ColorLimit;
      setUpdateDOM(new Date().getMilliseconds())
    }

    const handleShowMore = (e:React.MouseEvent<HTMLAnchorElement> |  null) => {
      if(e){
        e.preventDefault();
      }
      const length = itemsIndex.current + ColorLimit > differentColors.length ? differentColors.length : itemsIndex.current + ColorLimit;
      for(let i = 0;i <  differentColors.length; i++) {
        items.current.push(differentColors[i]);
      }

      itemsIndex.current = differentColors.length ;
      setUpdateDOM(new Date().getMilliseconds())
    } 

    const [selectedValue, setSelectedValue] = useState( previousChoiceId);

    const prepareRadioGroupSections = (differentColors: Array<string>) => {
      return items.current.map((eachColor:string, index)=>{
        const sameColorArr = choices[eachColor];
        const filteredValueArr = sameColorArr.filter((eachChoice:Choice)=> eachChoice.choiceid === selectedValue);
        
        return (<div key={eachColor} className={cssStyles[`Colors_radio_group`]}>

          <Box component="div" sx={{position: 'relative'}} className={cssStyles["color-wrapper"]}>
          {prepareSingleRadioGroup(sameColorArr)}
          <FormControlLabel
                      key={sameColorArr[0].choiceid}
                      value={sameColorArr[0].choiceid}
                      data-answer={sameColorArr[0].choice.split("-")[0]}
                      control={
                        <Radio
                          checkedIcon={<RadioButtonCheckedIcon sx={{color: 'primary.main'}} />}
                          icon={<RadioButtonUncheckedIcon sx={{color: 'secondary.main'}} />}
                          classes={{checked: cssStyles["color-checked"]}}
                          checked={selectedValue ? (filteredValueArr.length > 0 ) : sameColorArr[0].selected} 
                        />
                      }
                      label=""
                    />
         </Box>           
        </div>)
      })
    }

    

    useLayoutEffect(()=>{
      if(previousChoiceId){
        setSelectedAnswer([getAnswerObject(previousChoiceId)])
      }
    },[previousChoiceId])

    const setAnswer = (event: React.ChangeEvent<HTMLInputElement>) => {
      setSelectedValue(event.target.value);
      setStateForColorPallete(event.target.value);
    }

    const setStateForColorPallete = (selectedValue:string) => {
      setSelectedAnswer((previousState:any) => {
        let valuePresent = false;
        for(let i=0;i<previousState.length;i++){
          if(previousState[i].choiceid == selectedValue) {
            valuePresent=true;
            break;
          }
        }
        if(valuePresent){
          return previousState;
        }
        
        return [ getAnswerObject(selectedValue)]
      })
    }

    const getAnswerObject = (value: string) => {
     let color:any="";
     for(let index=0;index<items.current.length;index++){
        let eachItem = items.current[index];
        color= choices[eachItem].filter((eachChoice:Choice)=> eachChoice.choiceid === value) as Choice[];
        if(color && color.length>0){
          break;
        }
     }
      return {
        choiceid: value,
        answer:  color[0].choice.split("-")[0]
      }
    }

    const prepareSingleRadioGroup = (sameColorArr:any) => {
      const editDataObj = {responses: [{answers:[]}]} as any;
      sameColorArr.map((eachColorObj:any)=>{
        if(eachColorObj.selected){
          const selectedColorObj = JSON.parse(JSON.stringify(eachColorObj))
          selectedColorObj.choice = eachColorObj.choice.split("-")[0];
          editDataObj.responses[0].answers.push(selectedColorObj);
        }
      })
      return (
      <VerticalSingleSelection 
       key={selectedAnswer}
       selectedAnswer = {selectedAnswer}  
       setSelectedAnswer={setSelectedAnswer} 
       choices={sameColorArr} 
       editData={editDataObj}
       props={{"colorPallete": true }} />)
    }

    return (
      <div className={cssStyles["radio-groups"]}>
        <FormControl component="fieldset" fullWidth={true}>
          <RadioGroup
            aria-label="radio-buttons"
            name="radio-buttons-group"
            className={cssStyles["normal-flow"]}
            key={itemsIndex.current}
            value={selectedValue}
            onChange={(e) => setAnswer(e)}
          >
            {prepareRadioGroupSections(differentColors)}
          </RadioGroup>
        </FormControl>

        {
          <>
          {
            differentColors.length > ColorLimit && (
              itemsIndex.current < differentColors.length ? <a href='#' className={cssStyles['show-more']} onClick={handleShowMore}>Show more <MoreVertIcon /></a> : <a href='#' className={cssStyles['show-more']} onClick={handleShowLess}></a> /**Show less */
            )
          }
          </>
        }
      </div>
    )
}

export default ClientComponent(ColorPalleteSingleSelection);